import * as yup from 'yup';

import { AddressCountryString } from '../../../../../../../api/schemas/addressSchema';

export const addressFieldsValidationSchemaObject = {
    address: yup.string().nullable(),
    postalCode: yup.string().nullable(),
    postalBox: yup.string().nullable(),
    city: yup.string().nullable(),
    province: yup.string().nullable(),
    country: yup.string().nullable()
};

export const getEmptyAddressFields = (addressObj?: AddressCountryString) => {
    return {
        address: addressObj?.address || '',
        postalCode: addressObj?.postalCode || '',
        postalBox: addressObj?.postalBox || '',
        city: addressObj?.city || '',
        province: addressObj?.province || '',
        country: addressObj?.country || null
    };
};

export const addressValidationSchemaObject = {
    address: yup.object().shape(addressFieldsValidationSchemaObject).nullable().default(null)
};
